var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 50,
    viewBox: "0 0 42.43 42.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #305549;\n      }\n\n      .cls-3 {\n        isolation: isolate;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    className: "cls-1",
    cx: 21.21,
    cy: 21.21,
    r: 21.21
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.28,26.69c1.68-1.39,3-2.53,3.97-3.42,.97-.89,1.79-1.83,2.46-2.8s1-1.93,1-2.85c0-.7-.16-1.25-.49-1.65-.33-.39-.81-.59-1.47-.59s-1.16,.24-1.53,.73c-.37,.49-.55,1.18-.55,2.07h-4.24c.03-1.46,.35-2.67,.94-3.65,.59-.98,1.37-1.7,2.34-2.16,.97-.46,2.04-.69,3.23-.69,2.04,0,3.58,.52,4.62,1.57,1.04,1.05,1.56,2.41,1.56,4.09,0,1.83-.63,3.54-1.88,5.1-1.25,1.57-2.85,3.1-4.78,4.59h6.94v3.57H11.48v-3.27c.58-.46,.85-.68,.8-.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.94,18.72h-5.8c.04,.52,.21,.92,.5,1.19,.29,.28,.66,.41,1.09,.41,.64,0,1.08-.27,1.33-.81h2.73c-.14,.55-.39,1.04-.76,1.48-.37,.44-.82,.79-1.37,1.04-.55,.25-1.17,.38-1.85,.38-.82,0-1.55-.18-2.19-.53-.64-.35-1.14-.85-1.5-1.5s-.54-1.41-.54-2.28,.18-1.63,.53-2.28c.36-.65,.85-1.15,1.49-1.5,.64-.35,1.38-.53,2.21-.53s1.53,.17,2.16,.51,1.12,.82,1.48,1.46c.35,.63,.53,1.36,.53,2.2,0,.24-.01,.49-.04,.75Zm-2.58-1.42c0-.44-.15-.79-.45-1.05-.3-.26-.68-.39-1.12-.39s-.79,.12-1.09,.38-.48,.6-.55,1.06h3.21Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecond);
export default __webpack_public_path__ + "static/media/second.2958be948ce6993117c98f4078e358fa.svg";
export { ForwardRef as ReactComponent };